import { combineReducers } from '@reduxjs/toolkit';
import { ModelReducers } from './modelReducers';
import { eventsEntity } from './events';
import { photosEntity } from './photos';
import { deviceDetailsEntity } from './deviceDetails';
import { chambersEntity } from './chambers';
import { clustersEntity } from './clusters';
import { notesEntity } from './notes';
import { siteInstallationInfoEntity } from './siteInstallationInfo';
import { maintenanceLogEntity } from './maintenanceLog';
import { chambersMapStore } from '../features/dashboard/sites-map/store';
import { dashboardStats } from './stats';
import { sitesListSlice } from './siteList';
import { pipesEntity } from '@store/pipes';
import { rainfallEntity } from '@store/rainfall';
//
import { userProfileReducer } from './library-stores/user-profile';
import { accountsReducer } from './library-stores/accounts';
import { alarmSubscriptionsReducer } from './alarmSubscriptions/AlarmSubscriptionsReducer';

const rootReducer = combineReducers({
  [ModelReducers.events]: eventsEntity.reducer,
  [ModelReducers.photos]: photosEntity.reducer,
  [ModelReducers.chambers]: chambersEntity.reducer,
  [ModelReducers.deviceDetails]: deviceDetailsEntity.reducer,
  [ModelReducers.notes]: notesEntity.reducer,
  [ModelReducers.siteInstallationInfo]: siteInstallationInfoEntity.reducer,
  rainfall: rainfallEntity.reducer,
  maintenanceLog: maintenanceLogEntity.reducer,
  pipesList: pipesEntity.reducer,
  chambersMap: chambersMapStore.reducer,
  clusters: clustersEntity.reducer,
  sitesList: sitesListSlice.reducer,
  dashboardStats: dashboardStats.reducer,
  // library
  [accountsReducer.slice.name]: accountsReducer.slice.reducer,
  [userProfileReducer.slice.name]: userProfileReducer.slice.reducer,
  // new
  [alarmSubscriptionsReducer.slice.name]: alarmSubscriptionsReducer.slice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
